import type { SVGProps } from "react";
const SvgPlaneArrival = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <defs>
      <linearGradient
        id="planeArrival_svg__a"
        x1={7.85}
        x2={16.8}
        y1={13.4}
        y2={21.8}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7f78a1" stopOpacity={0.95} />
        <stop offset={1} stopColor="#7f78a1" stopOpacity={0.5} />
      </linearGradient>
      <linearGradient
        id="planeArrival_svg__b"
        x1={13.7}
        x2={10}
        y1={6.8}
        y2={12.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#86e8ff" />
        <stop offset={1} stopColor="#00a1fc" />
      </linearGradient>
      <linearGradient
        id="planeArrival_svg__c"
        x1={11}
        x2={14.2}
        y1={2.64}
        y2={15}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.6} />
        <stop offset={0.5} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.3} />
      </linearGradient>
    </defs>
    <path
      fill="url(#planeArrival_svg__a)"
      d="M19.62 17.2H4.52c-.35 0-.63.3-.63.68 0 .36.28.67.63.67h15.1c.34 0 .63-.3.63-.67s-.3-.67-.63-.67"
    />
    <path
      fill="url(#planeArrival_svg__b)"
      d="M4.69 9.13c.07.53.43.95.93 1.1l11.75 3.4c1.57.44 2.79-.21 2.95-1.08.11-.61-.13-1.76-2.45-2.25l-3.86-.8a1 1 0 0 1-.64-.46l-3.3-5.42a.8.8 0 0 0-.52-.37l-.45-.1c-.16-.04-.32.12-.3.29l.84 5.12-2.25-.48-2.06-2.72a.5.5 0 0 0-.5-.19l-.38.08a.3.3 0 0 0-.25.35z"
    />
    <path
      fill="url(#planeArrival_svg__c)"
      d="M9.64 3.62q.1.06.18.17l3.3 5.42a1.3 1.3 0 0 0 .82.58l3.86.81q.9.2 1.47.54c.82.52.8 1.13.76 1.37q-.09.37-.47.64c-.52.34-1.3.4-2.1.18L5.71 9.93l-.25-.1a1 1 0 0 1-.48-.76L4.5 5.55l.38-.08a.2.2 0 0 1 .22.08l2.07 2.73.06.08.1.02 2.24.48.45.1-.08-.47-.81-5.02.36.08q.09.02.16.07m.17-.27-.26-.1-.45-.1c-.16-.04-.32.12-.29.29l.83 5.12-2.25-.48-2.06-2.72a.5.5 0 0 0-.5-.19l-.38.08a.3.3 0 0 0-.25.35l.49 3.53c.05.4.28.75.6.95q.15.1.33.15l11.75 3.4c1.57.44 2.79-.21 2.95-1.08.08-.43-.02-1.13-.89-1.67a5 5 0 0 0-1.56-.58l-3.85-.8a1 1 0 0 1-.65-.46l-3.3-5.42a1 1 0 0 0-.26-.27"
    />
  </svg>
);
export default SvgPlaneArrival;
